import { defineNuxtRouteMiddleware } from '#imports'
import { useAuthService } from '@b2ag/auth'

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.name === 'register') {
    const auth = useAuthService()
    await auth.signin()
  }
})
